import React, { useState } from 'react';
import { faqItems } from './JsonLdSchema';

export default function FAQAccordion({ items = faqItems }) {
  const [open, setOpen] = useState(null);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {items.map((item, i) => {
        const isOpen = open === i;
        return (
          <div
            key={i}
            style={{
              border: `1px solid ${isOpen ? '#CC0000' : '#e5e7eb'}`,
              borderRadius: 12,
              overflow: 'hidden',
              transition: 'border-color 0.2s',
              background: '#fff',
            }}
          >
            <button
              onClick={() => setOpen(isOpen ? null : i)}
              aria-expanded={isOpen}
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '18px 24px',
                background: 'none',
                border: 'none',
                textAlign: 'left',
                cursor: 'pointer',
                gap: 16,
              }}
            >
              <span style={{ fontSize: 15, fontWeight: 600, color: '#111827', lineHeight: 1.4 }}>
                {item.question}
              </span>
              <span style={{
                flexShrink: 0,
                width: 28, height: 28,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                background: isOpen ? '#CC0000' : '#f3f4f6',
                borderRadius: '50%',
                color: isOpen ? '#fff' : '#6b7280',
                fontSize: 18, fontWeight: 700,
                transition: 'all 0.2s',
              }}>
                {isOpen ? '−' : '+'}
              </span>
            </button>
            {isOpen && (
              <div style={{ padding: '0 24px 20px', borderTop: '1px solid #f3f4f6' }}>
                <p style={{ fontSize: 15, color: '#4b5563', lineHeight: 1.7, marginTop: 16 }}>
                  {item.answer}
                </p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
